export { default } from './Burns';
